import PlaceholderImage from '../../../assets/placeholder-image-small.png?inline';
import useCategories from '../../../hooks/useCategories';
import { Image } from './CategoryImageStyle';
import { SyntheticEvent, useEffect, useRef, useState } from 'react';

interface CategoryImageProps {
  slug?: string;
}

function CategoryImage({ slug }: CategoryImageProps) {
  const { category } = useCategories(slug);

  const [hideSkeletonUI, setHideSkeletonUI] = useState<boolean>(false);

  const rootRef = useRef<HTMLImageElement>(null);

  const onImageError = (e: SyntheticEvent<HTMLImageElement, Event>) => {
    e.currentTarget.src = PlaceholderImage;
    setHideSkeletonUI(true);
  };

  const onImageLoad = () => {
    setTimeout(() => setHideSkeletonUI(true), 0);
  };

  useEffect(() => {
    if (category && slug && rootRef.current && hideSkeletonUI) {
      const parent = rootRef.current.parentElement?.parentElement;
      parent?.classList.add('show-content');
    }
  }, [category, slug, hideSkeletonUI]);

  if (!slug) {
    return null;
  }

  return (
    <Image
      ref={rootRef}
      src={category?.primaryImage?.url ?? PlaceholderImage}
      alt={category?.primaryImage?.alt ?? 'category-image'}
      onError={onImageError}
      onLoad={onImageLoad}
    />
  );
}

export default CategoryImage;
